module.exports = __webpack_public_path__ + "img/favicon.481ff757.png";